import axios from "axios";
import toast from "react-hot-toast";

const BACKEND_URL = "https://amal.platform.simplifii.com/api/v1/";



export const RequestServer = async(
  url,
  method,
  body,
  configs
) => {
  const authToken = localStorage.getItem("authToken");
  const controller = new AbortController();

  const id = setTimeout(() => {
    controller.abort();
    // toast.error("Unable to connect to the server!");
  }, 30000);

  const headers = {
    "Content-Type": "application/json",
  };

  if (authToken) headers.Authorization = authToken;

  const response = await axios({
    method: method,
    url: BACKEND_URL + url,
    data: body ? body : undefined,
    headers: headers,
    signal: controller.signal,
  });
  clearTimeout(id);

  if (response.status === 200) {
    if (configs?.successMessage) {
      toast.success(configs.successMessage);
    }
    return response.data;
  } else {
    toast.error(
      configs?.errorMessage ||
        "An error occurred while processing your request!"
    );
  }
};
